import React from "react";

export default function DoneIcon() {
  return (
    <React.Fragment>
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 54.5C44.598 54.5 54 45.098 54 33.5C54 21.902 44.598 12.5 33 12.5C21.402 12.5 12 21.902 12 33.5C12 45.098 21.402 54.5 33 54.5Z"
          fill="#84F5BA"
        />
        <circle
          cx="30"
          cy="30.5"
          r="22"
          fill="white"
          stroke="#222222"
          strokeWidth="2"
        />
        <path
          d="M22.5 32L28.8214 36.5L38 23"
          stroke="#222222"
          strokeWidth="2"
        />
      </svg>
    </React.Fragment>
  );
}
